/// <reference path="../../../app.definition.ts" />

angular.module('eCareVault.common.directives').directive('pageTracker', ['$compile', ($compile) => {
    return (scope, element, attrs) => {
    console.log("Initializing pageCompleteNotifier for page", attrs.pageTracker)
    let trackerEl = angular.element('<page-complete-notifier page-name="' + attrs.pageTracker + '"></page-complete-notifier>');
    element.append(trackerEl);
    $compile(trackerEl)(scope);
  };
}]);
